import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  FilterValues,
  FinancialAccountActivityItem,
  FinancialAccountDetails,
  FinancialAccountJournalActivityItem,
  FinancialAccountListItem,
  FinancialAccountListRequest,
  LimitItem,
  RequestPageParams,
} from '@shared/models';

export const FinancialAcccountActions = createActionGroup({
  source: 'Financial Acccount Actions',
  events: {
    'Load Financial Accounts': props<{ params: FinancialAccountListRequest }>(),
    'Load Financial Accounts Success': props<{ financialAccounts: FinancialAccountListItem[]; totalElements: number }>(),
    'Load Financial Accounts Failure': props<{ error: string }>(),
    'Set Financial Accounts Active Filters': props<{ filters: FilterValues }>(),
    'Load Financial Account Limits': emptyProps,
    'Load Financial Account Limits Success': props<{ financialAccountLimits: LimitItem[] }>(),
    'Load Financial Account Limits Failure': props<{ error: string }>(),
    'Load Financial Account Details': emptyProps,
    'Load Financial Account Details Success': props<{ financialAccount: FinancialAccountDetails | null }>(),
    'Load Financial Account Details Failure': props<{ error: string }>(),
    'Update Financial Account Status': props<{ action: string }>(),
    'Update Financial Account Status Failure': props<{ error: string; action: string }>(),
    'Load Financial Account Activity': props<{ params: RequestPageParams }>(),
    'Load Financial Account Activity Success': props<{ items: FinancialAccountActivityItem[]; totalElements: number }>(),
    'Load Financial Account Activity Failure': props<{ error: string }>(),
    'Set Financial Accounts Activity Active Filters': props<{ filters: FilterValues }>(),
    'Load Journal Activity': props<{ params: RequestPageParams }>(),
    'Load Journal Activity Success': props<{ items: FinancialAccountJournalActivityItem[]; totalElements: number }>(),
    'Load Journal Activity Failure': props<{ error: string }>(),
    'Set Journal Activity Active Filters': props<{ filters: FilterValues }>(),
  },
});
